"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateTravelAgentAutoApproval = exports.evaluateTravelAgentCategory = exports.evaluateHostAgencyCategory = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const autoApprovedTravelAgentCategories = [
    legacy_enums_1.TravelAgentCategory.INTRAIL,
    legacy_enums_1.TravelAgentCategory.TAHAC,
    legacy_enums_1.TravelAgentCategory.TAHAD,
    legacy_enums_1.TravelAgentCategory.CITA,
];
const evaluateHostAgencyCategory = (hostAgency) => {
    if (hostAgency._id === "INTRAIL") {
        return legacy_enums_1.TravelAgentCategory.INTRAIL;
    }
    if (hostAgency.commissionPercentage > 0) {
        return legacy_enums_1.TravelAgentCategory.TAHAC;
    }
    return legacy_enums_1.TravelAgentCategory.TAHAD;
};
exports.evaluateHostAgencyCategory = evaluateHostAgencyCategory;
const evaluateTravelAgentCategory = (commissionPercentage, hostAgency) => {
    if (hostAgency) {
        return (0, exports.evaluateHostAgencyCategory)(hostAgency);
    }
    return commissionPercentage && commissionPercentage > 0 ? legacy_enums_1.TravelAgentCategory.CITA : legacy_enums_1.TravelAgentCategory.DITA;
};
exports.evaluateTravelAgentCategory = evaluateTravelAgentCategory;
const evaluateTravelAgentAutoApproval = (travelAgentCategory) => {
    return autoApprovedTravelAgentCategories.includes(travelAgentCategory);
};
exports.evaluateTravelAgentAutoApproval = evaluateTravelAgentAutoApproval;
//# sourceMappingURL=evaluate-travel-agent-category.js.map